import { onError } from "@apollo/client/link/error";
import { toast } from "react-toastify";

// APIs that must not trigger logout on 401 (public e-sign portal)
const ESIGN_BYPASS_APIS = [
  'get_signing_document',
  'preview_signed_document',
  'update_signer_status',
];

const getOperationField = (operation) => {
  try {
    return operation.query?.definitions?.[0]?.selectionSet?.selections?.[0]?.name?.value || '';
  } catch {
    return '';
  }
};

export const errorLink = onError(
  ({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
      console.error(`graphQLErrors:`, graphQLErrors);
      // toast.error(graphQLErrors[0].message);
    }

    if (networkError) {
      console.error(`networkError:`, networkError.result);
      if (networkError.statusCode === 401) {
        const operationName = (operation?.operationName || getOperationField(operation)).toLowerCase();
        if (ESIGN_BYPASS_APIS.includes(operationName)) return;

        toast.error("Unauthenticated");
        localStorage.removeItem("user_information");
        localStorage.removeItem("isUserDataSet");
        window.location.href = "/login";
      }
    }
  }
);
